import PropTypes from "prop-types"
import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import TabNavigation from "components/tablink/tablink"

class OfficeMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    render() {
        const navItems = [
            {
                id: 'events',
                label: 'Events',
                link: `/office/events`
            },
            {
                id: 'message',
                label: 'Message',
                link: `/office/message`
            },
            {
                id: 'resource',
                label: 'Resource',
                link: `/office/resource`
            },
        ];
        return (
            <React.Fragment>
                <TabNavigation navItems={navItems}

                />
            </React.Fragment>
        )
    }
}
OfficeMenu.propTypes = {
    match: PropTypes.object
}
export default withRouter(OfficeMenu)
